import React, { useEffect } from 'react';
import System from 'src/helper/system';
import { useUserStore } from 'src/hooks/admin/user';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';


const ShippingAddressDetail = (props) => {
    const [{ userShippingAddress }, { get_user_shipping_address_detail }, { }] = useUserStore();
    const userId = props.userId;
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    useEffect(() => {
        async function fetchHere() {
            const data = await get_user_shipping_address_detail(userId);
            if (data?.payload?.Message) {
                system_alert_indicator({
                    name: "accessDenied",
                    message: data?.payload?.Message,
                    type: "danger",
                    isDisplayIcon: true,
                    isDisplay: false
                });
            }
        }
        fetchHere();
    }, []);
    const { addressType } = Constants;

    const openShippingMethodPopup = (addressInfo) => {
        System.popup('ShippingAddressPopup', addressInfo);
    }

    return (
        <div className='container'>
            <div className='user-details-shipping-container'>
                <div className='d-flex align-items-center justify-content-between profile-title ms-1 me-1'>
                    <div className='font-arial font-arial font-16'><b> Shipping Address</b></div>

                </div>
                <div className=''>
                    <div className='profile-box-container'>

                        {userShippingAddress?.length > 0 && userShippingAddress.map((shipadd, index) => (
                            <div className="profile-box-shipping-column">
                                <div className='profile-box-shipping'>

                                    <div className='profile-box'>
                                        <div className='mb-2 mt-1'>
                                            <div className='companyname ps-0'><b>{shipadd.companyName}</b></div>
                                            <div
                                                className='companyaddress'>{shipadd.address.addressLineOne}<br /> {Helper.valueIsNotNull(shipadd.address.addressLineTwo) ? <>{shipadd.address.addressLineTwo}
                                                    <br /></> : ""} {shipadd.address.cityName}, {shipadd.address.stateName} {shipadd.address.postalCode}, <br /> {shipadd.address.countryName}.
                                            </div>
                                            <a className='mt-2 d-inline-block' onClick={() => openShippingMethodPopup({
                                                'type': addressType.SHIP_TO,
                                                'addressInfo': shipadd, 'userId': userId
                                            })}>Edit Address</a>
                                        </div>


                                    </div>

                                </div>


                            </div>
                        ))}

                        {userShippingAddress.length === 0 &&
                            <div className='container mt-3'>
                                <div className="alert alert-info" role="alert">
                                    <span>
                                        No shipping address found.
                                    </span>
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close"  >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShippingAddressDetail;





